export default [
  {
    path: "/9447c574-ea70",
    children: [
      {
        path: "6LjoDOqDq",
        name: "users",
        meta: {
          title: "Users",
          authRequired: true,
          acc: ["y38989"],
        },
        component: () => import("@/views/users/users"),
      },
      {
        path: "fN3yNRp",
        name: "newuser",
        meta: {
          title: "New User",
          authRequired: true,
          acc: ["y93621"],
        },
        component: () => import("@/views/users/new"),
      },
      {
        path: "jpHAKRYlk/:tr?",
        name: "user",
        meta: {
          title: "View user",
          authRequired: true,
          acc: ["y38295"],
        },
        component: () => import("../views/users/view"),
      },
      {
        path: "uYdswx/:tr?",
        name: "edituser",
        meta: {
          title: "Update User",
          authRequired: true,
          acc: ["y79239"],
        },
        component: () => import("../views/users/edit"),
      },
    ],
  },
];
